import { render, staticRenderFns } from "./SelectCampaign.vue?vue&type=template&id=4fed6642&scoped=true&"
import script from "./SelectCampaign.vue?vue&type=script&lang=js&"
export * from "./SelectCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fed6642",
  null
  
)

export default component.exports